import { Pipe, PipeTransform } from '@angular/core';
import { TrainingProposalsPluginService } from './trainingproposals-plugin.service';

@Pipe({
    name: 'coursepipe',
    standalone: false
})
export class CoursePipe implements PipeTransform {
  public courses: any;

  constructor(private service: TrainingProposalsPluginService) {
    this.service.getCourses().subscribe((data) => {
      this.courses = data;
    });
  }

  transform(id: string): any {
    return this.service.getValue(id, this.courses);
  }
}
